<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div
                class="d-flex justify-content-between align-items-center mb-4"
              >
                <h4 class="card-title mb-0">
                  <i class="fas fa-history"></i> Histórico de Fechamentos de Dia
                </h4>
                <button
                  class="btn btn-sm btn-primary"
                  @click="carregarFechamentos"
                >
                  <i class="fas fa-sync"></i> Atualizar
                </button>
              </div>

              <!-- Tabela de Fechamentos -->
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>UUID</th>
                      <th>Data/Hora</th>
                      <th>Usuário</th>
                      <th>Qtd. Senhas</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="fechamento in fechamentos" :key="fechamento.id">
                      <td>
                        <small class="text-monospace"
                          >{{ fechamento.uuid.substring(0, 8) }}...</small
                        >
                      </td>
                      <td>{{ fechamento.data_fechamento }}</td>
                      <td>{{ fechamento.user }}</td>
                      <td class="text-center">
                        <span class="badge badge-info">{{
                          fechamento.qtd_senhas_finalizadas
                        }}</span>
                      </td>
                      <td>
                        <span
                          class="badge"
                          :class="'badge-' + fechamento.status_cor"
                        >
                          {{ fechamento.status_label }}
                        </span>
                      </td>
                      <td>
                        <button
                          v-if="fechamento.status === 'ok' && podeRollback"
                          class="btn btn-sm btn-warning mr-1"
                          @click="abrirModalRollback(fechamento)"
                          title="Fazer Rollback"
                        >
                          <i class="fas fa-undo"></i> Rollback
                        </button>
                        <button
                          v-if="
                            fechamento.status === 'rollback' && podeRollback
                          "
                          class="btn btn-sm btn-success mr-1"
                          @click="abrirModalReverter(fechamento)"
                          title="Reverter Rollback"
                        >
                          <i class="fas fa-redo"></i> Reverter
                        </button>
                        <button
                          class="btn btn-crud view mr-1"
                          @click="verDetalhes(fechamento)"
                          title="Ver Detalhes"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="fechamentos.length === 0">
                      <td colspan="6" class="text-center text-muted">
                        <i class="fas fa-inbox fa-2x mb-2"></i>
                        <p>Nenhum fechamento encontrado</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Paginação -->
              <div
                class="col-md-6 mt-3 mx-auto d-flex justify-content-center align-items-center"
              >
                <pagination
                  :records="total"
                  :options="options"
                  :per-page="15"
                  @paginate="carregarFechamentos"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>

    <!-- Modal de Rollback -->
    <b-modal
      id="modalRollback"
      ref="modalRollback"
      title="Realizar Rollback - ATENÇÃO!"
      size="lg"
      hide-footer
    >
      <div v-if="fechamentoSelecionado">
        <div
          class="alert alert-danger border-left-danger shadow-sm mb-4"
          style="border-left: 4px solid #e74a3b"
        >
          <div class="d-flex align-items-center mb-2">
            <i
              class="fas fa-exclamation-triangle fa-2x text-danger mr-1 ml-1 mt-1"
            ></i>
            <h5 class="mb-0 font-weight-bold">ATENÇÃO: Ação Crítica!</h5>
          </div>
          <p class="mb-2 ml-1">
            Você está prestes a <strong>REVERTER</strong> o fechamento de dia
            realizado em
            <strong>{{ fechamentoSelecionado.data_fechamento }}</strong
            >.
          </p>
          <p class="mb-0 ml-1">
            Esta ação irá
            <strong
              >reativar
              {{ fechamentoSelecionado.qtd_senhas_finalizadas }} senhas</strong
            >
            que foram finalizadas neste fechamento.
          </p>
        </div>

        <form @submit.prevent="confirmarRollback" class="mt-4">
          <div class="form-group">
            <label class="font-weight-bold">
              <span class="text-danger">*</span> Login do Autorizador
              (Admin/Gestor):
            </label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white"
                  ><i class="fas fa-envelope text-muted"></i
                ></span>
              </div>
              <input
                type="text"
                class="form-control"
                v-model="rollbackForm.login_autorizador"
                required
              />
            </div>
            <small class="form-text text-muted">
              Deve ser um usuário diferente do logado com nível (Gestor) ou
              (Admin)
            </small>
          </div>

          <div class="form-group">
            <label class="font-weight-bold">
              <span class="text-danger">*</span> Senha do Autorizador:
            </label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white"
                  ><i class="fas fa-lock text-muted"></i
                ></span>
              </div>
              <input
                type="password"
                class="form-control"
                v-model="rollbackForm.senha_autorizador"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-bold">
              <span class="text-danger">*</span> Motivo do Rollback (mínimo 10
              caracteres):
            </label>
            <textarea
              class="form-control"
              v-model="rollbackForm.motivo"
              rows="4"
              placeholder="Descreva detalhadamente o motivo desta ação..."
              required
              minlength="10"
              style="resize: none"
            ></textarea>
            <small class="form-text text-muted">
              {{ rollbackForm.motivo.length }}/10 caracteres
            </small>
          </div>

          <div
            class="alert alert-warning border-left-warning shadow-sm mb-3"
            style="border-left: 4px solid #f6c23e"
          >
            <div class="d-flex align-items-start">
              <i
                class="fas fa-info-circle fa-lg text-warning mr-2 ml-1 mt-1"
              ></i>
              <span
                >Esta ação será <strong>registrada no sistema</strong> com seu
                nome, o nome do autorizador, IP de origem e motivo.</span
              >
            </div>
          </div>

          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary mr-2"
              @click="fecharModalRollback"
            >
              <i class="fas fa-times"></i> Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-warning"
              :disabled="rollbackForm.motivo.length < 10"
            >
              <i class="fas fa-undo"></i> Confirmar Rollback
            </button>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- Modal de Reverter -->
    <b-modal
      id="modalReverter"
      ref="modalReverter"
      title="Reverter Rollback - ATENÇÃO!"
      size="lg"
      hide-footer
    >
      <div v-if="fechamentoSelecionado">
        <div
          class="alert alert-danger border-left-danger shadow-sm mb-4"
          style="border-left: 4px solid #e74a3b"
        >
          <div class="d-flex align-items-center mb-2">
            <i
              class="fas fa-exclamation-triangle fa-2x text-danger mr-1 ml-1 mt-1"
            ></i>
            <h5 class="mb-0 font-weight-bold">ATENÇÃO: Ação IRREVERSÍVEL!</h5>
          </div>
          <p class="mb-2 ml-1">
            Você está prestes a <strong>REVERTER O ROLLBACK</strong> realizado
            neste fechamento.
          </p>
          <p class="mb-0 ml-1">
            Esta ação irá <strong>FINALIZAR NOVAMENTE</strong> as senhas que
            foram restauradas pelo rollback anterior. Use apenas em caso de erro
            no rollback.
          </p>
        </div>

        <form @submit.prevent="confirmarReverter" class="mt-4">
          <div class="form-group">
            <label class="font-weight-bold">
              <span class="text-danger">*</span> Email do Autorizador
              (Admin/Gestor):
            </label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white"
                  ><i class="fas fa-envelope text-muted"></i
                ></span>
              </div>
              <input
                type="email"
                class="form-control"
                v-model="reverterForm.login_autorizador"
                required
              />
            </div>
            <small class="form-text text-muted">
              Deve ser um usuário diferente do logado com nível (Gestor) ou
              (Admin)
            </small>
          </div>

          <div class="form-group">
            <label class="font-weight-bold">
              <span class="text-danger">*</span> Senha do Autorizador:
            </label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white"
                  ><i class="fas fa-lock text-muted"></i
                ></span>
              </div>
              <input
                type="password"
                class="form-control"
                v-model="reverterForm.senha_autorizador"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-bold">
              <span class="text-danger">*</span> Motivo da Reversão (mínimo 10
              caracteres):
            </label>
            <textarea
              class="form-control"
              v-model="reverterForm.motivo"
              rows="4"
              placeholder="Descreva detalhadamente o motivo desta reversão..."
              required
              minlength="10"
              style="resize: none"
            ></textarea>
            <small class="form-text text-muted">
              {{ reverterForm.motivo.length }}/10 caracteres
            </small>
          </div>

          <div
            class="alert alert-warning border-left-warning shadow-sm mb-3"
            style="border-left: 4px solid #f6c23e"
          >
            <div class="d-flex align-items-start">
              <i
                class="fas fa-info-circle fa-lg text-warning mr-2 ml-1 mt-1"
              ></i>
              <span
                >Esta ação será <strong>registrada no sistema</strong> com seu
                nome, o nome do autorizador, IP de origem e motivo.</span
              >
            </div>
          </div>

          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary mr-2"
              @click="fecharModalReverter"
            >
              <i class="fas fa-times"></i> Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-danger"
              :disabled="reverterForm.motivo.length < 10"
            >
              <i class="fas fa-redo"></i> Confirmar Reversão
            </button>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- Modal de Detalhes -->
    <b-modal
      id="modalDetalhes"
      ref="modalDetalhes"
      title="Detalhes do Fechamento"
      size="xl"
      hide-footer
    >
      <div v-if="fechamentoSelecionado">
        <div class="row">
          <div class="col-md-6">
            <p>
              <strong>UUID:</strong>
              <code>{{ fechamentoSelecionado.uuid }}</code>
            </p>
            <p>
              <strong>Data/Hora:</strong>
              {{ fechamentoSelecionado.data_fechamento }}
            </p>
            <p><strong>Usuário:</strong> {{ fechamentoSelecionado.user }}</p>
          </div>
          <div class="col-md-6">
            <p>
              <strong>Status:</strong>
              <span
                class="badge ml-2"
                :class="'badge-' + fechamentoSelecionado.status_cor"
              >
                {{ fechamentoSelecionado.status_label }}
              </span>
            </p>
            <p>
              <strong>Qtd. Senhas:</strong>
              <span class="badge badge-info ml-2">
                {{ fechamentoSelecionado.qtd_senhas_finalizadas }}
              </span>
            </p>
          </div>
        </div>

        <hr />

        <h5 class="mb-3">Histórico de Ações</h5>
        <div
          v-if="
            fechamentoSelecionado.rollback_logs &&
            fechamentoSelecionado.rollback_logs.length > 0
          "
        >
          <div
            v-for="(log, index) in fechamentoSelecionado.rollback_logs"
            :key="log.id"
            class="card mb-2"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h6>
                    <span class="badge badge-primary">#{{ index + 1 }}</span>
                    {{ log.acao_label }}
                  </h6>
                  <p class="mb-1">
                    <strong>Data/Hora:</strong> {{ log.data_acao }}
                  </p>
                  <p class="mb-1">
                    <strong>Solicitante:</strong> {{ log.solicitante }}
                  </p>
                  <p class="mb-1">
                    <strong>Autorizador:</strong> {{ log.autorizador }}
                  </p>
                  <p class="mb-1">
                    <strong>IP:</strong> <code>{{ log.ip_address }}</code>
                  </p>
                  <p class="mb-1">
                    <strong>Qtd. Senhas Afetadas:</strong>
                    <span class="badge badge-info">{{
                      log.qtd_senhas_afetadas
                    }}</span>
                  </p>
                  <p class="mb-0">
                    <strong>Motivo:</strong><br />
                    <em>{{ log.motivo }}</em>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-info">
          <i class="fas fa-info-circle"></i>
          Nenhuma ação de rollback registrada para este fechamento.
        </div>

        <div class="text-right mt-3">
          <button class="btn btn-secondary" @click="fecharModalDetalhes">
            <i class="fas fa-times"></i> Fechar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
import swal from "sweetalert";

export default {
  name: "FechamentoList",
  components: {
    vSelect,
    Pagination,
  },
  data() {
    return {
      loader: 0,
      fechamentos: [],
      fechamentoSelecionado: null,
      filtroStatus: null,
      statusOptions: [
        { label: "Todos", value: null },
        { label: "Ativo", value: "ok" },
        { label: "Revertido", value: "rollback" },
      ],
      rollbackForm: {
        login_autorizador: "",
        senha_autorizador: "",
        motivo: "",
      },
      reverterForm: {
        login_autorizador: "",
        senha_autorizador: "",
        motivo: "",
      },
      total: 0,
      page: 1,
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
    };
  },
  computed: {
    podeRollback() {
      const user = this.$store.state.user;

      console.log("Nível de Acesso do Usuário:", user.perfil_id);
      // Permite apenas para gestores (6) e admins (7)
      return user && (user.perfil_id === 6 || user.perfil_id === 7);
    },
  },
  methods: {
    setLoader(qtd) {
      const self = this;
      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;
        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
    carregarFechamentos(page) {
      const self = this;
      self.page = page || 1;
      self.$loading(true);

      const api = self.$store.state.api + "fechamentos?page=" + self.page;

      axios
        .get(api)
        .then((response) => {
          self.fechamentos = response.data.data;
          self.total = response.data.total;
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(
            "Erro",
            error.response?.data?.message || "Erro ao carregar fechamentos",
            "error"
          );
        });
    },
    filtrarFechamentos() {
      // Recarregar dados ao mudar o filtro
      this.carregarFechamentos();
    },
    abrirModalRollback(fechamento) {
      this.fechamentoSelecionado = fechamento;
      this.rollbackForm = {
        login_autorizador: "",
        senha_autorizador: "",
        motivo: "",
      };
      this.$refs.modalRollback.show();
    },
    fecharModalRollback() {
      this.$refs.modalRollback.hide();
      this.fechamentoSelecionado = null;
    },
    confirmarRollback() {
      const self = this;

      swal({
        title: "Confirmar Rollback?",
        text: `Você está prestes a REVERTER o fechamento de dia.\n\nEsta ação irá reativar ${self.fechamentoSelecionado.qtd_senhas_finalizadas} senhas.\n\nEsta ação será registrada no sistema.`,
        icon: "warning",
        buttons: {
          cancel: {
            text: "Cancelar",
            visible: true,
            className: "btn-secondary",
          },
          confirm: {
            text: "Confirmar Rollback",
            className: "btn-warning",
          },
        },
        dangerMode: false,
      }).then((confirmar) => {
        if (confirmar) {
          self.$loading(true);

          const api = self.$store.state.api + "fechamentos/rollback";
          const data = {
            uuid_fechamento: self.fechamentoSelecionado.uuid,
            login_autorizador: self.rollbackForm.login_autorizador,
            senha_autorizador: self.rollbackForm.senha_autorizador,
            motivo: self.rollbackForm.motivo,
          };

          axios
            .post(api, data)
            .then((response) => {
              self.$loading(false);
              if (response.data.success) {
                swal({
                  title: "Sucesso!",
                  text: `Rollback realizado com sucesso!\n\n${response.data.data.qtd_senhas_restauradas} senhas foram restauradas.`,
                  icon: "success",
                  button: "OK",
                });
                self.fecharModalRollback();
                self.carregarFechamentos();
              }
            })
            .catch((error) => {
              self.$loading(false);
              swal({
                title: "Erro",
                text:
                  error.response?.data?.message || "Erro ao realizar rollback",
                icon: "error",
                button: "OK",
              });
            });
        }
      });
    },
    abrirModalReverter(fechamento) {
      this.fechamentoSelecionado = fechamento;
      this.reverterForm = {
        login_autorizador: "",
        senha_autorizador: "",
        motivo: "",
      };
      this.$refs.modalReverter.show();
    },
    fecharModalReverter() {
      this.$refs.modalReverter.hide();
      this.fechamentoSelecionado = null;
    },
    confirmarReverter() {
      const self = this;

      swal({
        title: "Confirmar Reversão?",
        text: `ATENÇÃO: Você está prestes a REVERTER O ROLLBACK.\n\nEsta ação irá FINALIZAR NOVAMENTE as senhas que foram restauradas pelo rollback anterior.\n\n⚠️ ESTA AÇÃO É IRREVERSÍVEL!`,
        icon: "error",
        buttons: {
          cancel: {
            text: "Cancelar",
            visible: true,
            className: "btn-secondary",
          },
          confirm: {
            text: "Confirmar Reversão",
            className: "btn-danger",
          },
        },
        dangerMode: true,
      }).then((confirmar) => {
        if (confirmar) {
          self.$loading(true);

          const api = self.$store.state.api + "fechamentos/reverter";
          const data = {
            uuid_fechamento: self.fechamentoSelecionado.uuid,
            login_autorizador: self.reverterForm.login_autorizador,
            senha_autorizador: self.reverterForm.senha_autorizador,
            motivo: self.reverterForm.motivo,
          };

          axios
            .post(api, data)
            .then((response) => {
              self.$loading(false);
              if (response.data.success) {
                swal({
                  title: "Reversão Concluída!",
                  text: `Reversão realizada com sucesso!\n\n${response.data.data.qtd_senhas_finalizadas} senhas foram finalizadas novamente.`,
                  icon: "success",
                  button: "OK",
                });
                self.fecharModalReverter();
                self.carregarFechamentos();
              }
            })
            .catch((error) => {
              self.$loading(false);
              swal({
                title: "Erro",
                text:
                  error.response?.data?.message || "Erro ao reverter rollback",
                icon: "error",
                button: "OK",
              });
            });
        }
      });
    },
    verDetalhes(fechamento) {
      this.fechamentoSelecionado = fechamento;
      this.$refs.modalDetalhes.show();
    },
    fecharModalDetalhes() {
      this.$refs.modalDetalhes.hide();
      this.fechamentoSelecionado = null;
    },
  },
  mounted() {
    const self = this;
    self.setLoader(30);
    self.carregarFechamentos();
    self.setLoader(70);
  },
};
</script>

<style scoped>
.text-monospace {
  font-family: "Courier New", monospace;
}

.badge {
  font-size: 0.9em;
  padding: 0.4em 0.8em;
}

.table td {
  vertical-align: middle;
}

.alert-heading {
  margin-bottom: 15px;
}

code {
  font-size: 0.9em;
  padding: 2px 6px;
  background-color: #f4f4f4;
  border-radius: 3px;
}

.card-body p {
  margin-bottom: 8px;
}

.form-text {
  font-size: 0.85em;
}
</style>
